// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles.css'
import VueLocalStorage from 'vue-localstorage'

import { TableComponent, TableColumn } from 'vue-table-component';

import moment from "moment";
import VueMomentJS from "vue-momentjs";
import PictureInput from "vue-picture-input";

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(VueMomentJS, moment);
Vue.use(VueLocalStorage)

Vue.component('table-component', TableComponent);
Vue.component('table-column', TableColumn);
Vue.component('PictureInput', PictureInput);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js